"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _ref;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.NotificationsWrap = exports.Arrow = exports.Description = exports.Avatar = exports.AvatarWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var AvatarWrap = (0, _styled.default)('div')((_ref = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
}, _defineProperty(_ref, _mediaQueries.default.untilMedium, {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer'
}), _defineProperty(_ref, '>a', _defineProperty({}, _mediaQueries.default.untilMedium, {
  width: '100%'
})), _ref));
exports.AvatarWrap = AvatarWrap;
var Avatar = (0, _styled.default)('div')(function (_ref2) {
  var _ref3;

  var colors = _ref2.theme.colors;
  return _ref3 = {
    width: '4rem',
    height: '4rem',
    backgroundColor: colors.black,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    color: colors.white,
    position: 'relative',
    cursor: 'pointer'
  }, _defineProperty(_ref3, _mediaQueries.default.small, {
    width: '4.8rem',
    height: '4.8rem'
  }), _defineProperty(_ref3, "span", {
    textTransform: 'uppercase'
  }), _ref3;
});
exports.Avatar = Avatar;
var Description = (0, _styled.default)('p')(function (_ref4) {
  var space = _ref4.theme.space;
  return {
    display: 'inline-block',
    marginBottom: '0',
    fontSize: '1.6rem',
    fontWeight: 'bold',
    marginLeft: space.large
  };
}, function (_ref5) {
  var colors = _ref5.theme.colors;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      mega: {
        color: colors.white
      },
      primary: {
        color: colors.primary
      }
    }
  });
});
exports.Description = Description;
var Arrow = (0, _styled.default)(_Icon.default)(function (_ref6) {
  var _ref7;

  var colors = _ref6.theme.colors;
  return _ref7 = {
    position: 'relative',
    display: 'inline-block',
    marginLeft: 'auto'
  }, _defineProperty(_ref7, _mediaQueries.default.medium, {
    display: 'none'
  }), _defineProperty(_ref7, "svg", {
    stroke: colors.primary
  }), _ref7;
});
exports.Arrow = Arrow;
var NotificationsWrap = (0, _styled.default)('div')({
  position: 'relative'
});
exports.NotificationsWrap = NotificationsWrap;